export default __webpack_public_path__ + "static/media/PRIVACYPOLICY_en.192e91a5.docx";